export default {
  path: '/carga-de-selos-virtuais/:id',
  component: () => import('@/components/pages/VirtualSealsLoad/VirtualSealsLoad.vue')
}
